export const thumbnailTypes = ["jpg", "jpeg", "png", "gif", "svg"];
